import AssetField from '../../../contentful/AssetField';
import BlockEditor from '../../../block-editor/Editor';
import DatePicker, {registerLocale} from 'react-datepicker';
import dpLocale from 'date-fns/locale/nb';
import EntityCollectionField from '../../../contentful/EntityCollectionField';
import EntityField from '../../../contentful/EntityField';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import CustomVariables from '../misc/CustomVariables.js';
import {printCampaignVisibility} from '../campaigns/Campaigns.js';
import entity from '../../../../model/entity';
import MakeModelVariantField from '../misc/MakeModelVariantField.js';
import {Popover, OverlayTrigger} from 'react-bootstrap';
import Entity from '../../../contentful/Entity';
import {generateEditLink} from '/src/components/misc/utils';

import update from 'immutability-helper';
import React from 'react';


import 'react-datepicker/dist/react-datepicker.css';

registerLocale('nb', dpLocale);

const createSearcher = (
  contentType,
  params
) => {
  return ({
    query,
    offset,
    limit
  }) => {
    return entity.search({
      query: query,
      offset: offset,
      limit: limit,
      contentType: contentType,
      options: params
    });
  };
};

class Campaign extends React.Component {
  constructor(props) {
    super(props);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleDealersUpdate = this.handleDealersUpdate.bind(this);
    this.handleMakeModelVariantChange = this.handleMakeModelVariantChange.bind(this);

    this.urlUntouched = true;

    this.state = {
      campaignUrl: ''
    };
  }

  componentDidMount() {
    if (this.props.campaign && this.props.campaign.url) {
      this.urlUntouched = false;
      this.updateUrlState(this.props.campaign.url.toLowerCase());
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const event = {
      target: {
        name: name,
        value: asset
      }
    };

    this.handleFieldChange(event);
  }

  updateUrlState(url) {
    this.setState({
      campaignUrl: url
    });
  }

  handleMakeModelVariantChange(selections) {
    const change = {
      campaign: {}
    };

    change.campaign['makes'] = {
      $set: selections.makes
    };
    change.campaign['model'] = {
      $set: selections.model
    };
    change.campaign['variants'] = {
      $set: selections.variants
    };

    if (!selections.variants) {
      // Remove included stuff if variant is removed
      change.campaign['includedEquipments'] = {
        $set: []
      };
      change.campaign['includedFactoryEquipments'] = {
        $set: []
      };
      change.campaign['availableColors'] = {
        $set: []
      };

      // Reset price on fixed rate loan campaigns, if no variants are selected
      if (this.props.campaign.type === 'newcar-fixed-rate-loan') {
        change.campaign['price'] = {
          $set: null
        };
      }

      if (this.props.campaign.lease) {
        // Also remove variant if it exist
        change.campaign['lease'] = {
          $set: null
        };
      }
    }

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    const newData = {
      campaign: {}
    };

    let value = e.target.value;

    if (e.target.name === 'name' && (!this.props.campaign.url || this.urlUntouched)) {
      // Update URL field on name change if empty
      const url = value.replace(/[^\w.,-]/g, '-').toLowerCase();
      newData.campaign.url = {
        $set: url
      };

      this.updateUrlState(url);
    } else if (e.target.name === 'url') {
      this.urlUntouched = false;
      value = value.replace(/[^\w.,-]/g, '-').toLowerCase();
      this.updateUrlState(value);
    } else if (e.target.name === 'makes') {
      if (this.props.campaign.lease) {
        // Do not allow remove when a lease link exist
        return;
      }

      // Clear model, variants and lease on make clear
      if (!value || !value.length) {
        newData.campaign.model = {
          $set: null
        };
        newData.campaign.variants = {
          $set: []
        };
      }
    } else if (e.target.name === 'model') {
      if (this.props.campaign.lease) {
        // Do not allow remove when a lease link exist
        return;
      }

      // Clear variants and lease on model clear
      if (!value) {
        newData.campaign.variants = {
          $set: []
        };
      }
    } else if (e.target.name === 'lease') {
      // Remove available colors on lease remove
      if (!value) {
        newData.campaign.availableColors = {
          $set: []
        };
      }
    } else if (e.target.name === 'externalCampaignPage') {
      if (!this.props.campaign.callToActionHeader) {
        newData.campaign.callToActionHeader = {
          $set: '*Ekstern kampanjeside*'
        };
      }
      if (!this.props.campaign.callToActionText) {
        newData.campaign.callToActionText = {
          $set: '*Ekstern kampanjeside*'
        };
      }
      if (!this.props.campaign.callToActionForm) {
        newData.campaign.callToActionForm = {
          $set: 'Campaign'
        };
      }
      if (!this.props.campaign.callToActionButtonText) {
        newData.campaign.callToActionButtonText = {
          $set: 'Se kampanjen '
        };
      }
    }

    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    }

    newData.campaign[e.target.name] = {
      $set: value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleDateChange(inputName, date) {
    const event = {
      target: {
        name: inputName,
        value: date
      }
    };

    this.handleFieldChange(event);
  }

  handleDealersUpdate(elem, makeId, tag) {
    if (makeId || tag) {
      // Get all dealers with corresponding makes
      const dealers = this.props.dealers;
      const currentDealers = this.props.campaign.dealers || [];
      let currentDealerIds = [];

      if (currentDealers.length > 0) {
        currentDealerIds = this.props.campaign.dealers.map((dealer) => {
          return dealer.id;
        });
      }

      dealers.forEach((dealer) => {
        if (!currentDealerIds.includes(dealer.id)) {
          if (makeId) {
            if (dealer.makeIds.includes(makeId)) {
              currentDealers.push(dealer);
            }
          } else if (tag) {
            if (dealer.groupTags && dealer.groupTags.includes(tag)) {
              currentDealers.push(dealer);
            }
          }
        }
      });

      const event = {
        target: {
          name: 'dealers',
          value: currentDealers
        }
      };

      this.handleFieldChange(event);
    }
  }

  render() {
    if (this.props.campaign) {
      const campaign = this.props.campaign;

      // Create button group
      let buttons;
      if (this.props.makes) {
        const allMakes = this.props.makes;
        buttons = (
          <div className="btn-group" role="group">
            {allMakes.map((make, i) => {
              return (
                <button
                  key={i}
                  type="button"
                  className="btn btn-default btn-sm"
                  disabled={campaign.archived || this.props.working}
                  onClick={(e) => this.handleDealersUpdate(e, make.id)}
                >
                  Alle {make.name}
                </button>
              );
            })}
          </div>
        );
      }

      const variablesLocked = [];

      if (campaign.type !== 'newcar-loan' && campaign.price && campaign.price > 0) {
        variablesLocked.push(
          ['price', Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(campaign.price), ',-']
        );
      }
      if (campaign.type === 'newcar-loan') {
        if (campaign.loanRate) {
          variablesLocked.push(
            ['loanRate', campaign.loanRate, '%']
          );
        }

        if (campaign.minimumEquityPercentage) {
          variablesLocked.push(
            ['loanMinimumEquity', campaign.minimumEquityPercentage, '%']
          );
        }
      }
      if (campaign.type === 'newcar-fixed-rate-loan') {
        if (campaign.loanRate2) {
          variablesLocked.push(
            ['loanRate2', campaign.loanRate2, '%']
          );
        }
        if (campaign.loanRate) {
          variablesLocked.push(
            ['loanRate', campaign.loanRate, '%']
          );
        }
        if (campaign.minimumEquityPercentage) {
          variablesLocked.push(
            ['loanMinimumEquity', campaign.minimumEquityPercentage, '%']
          );
        }
        if (campaign.loanRateTotalTerms) {
          variablesLocked.push(
            ['loanRateTotalYears', campaign.loanRateTotalTerms / 12, 'år'],
            ['loanRateTotalTerms', campaign.loanRateTotalTerms, 'mnd']
          );
        }
        if (campaign.loanFixedRateTerms) {
          variablesLocked.push(
            ['loanFixedRateYears', campaign.loanFixedRateTerms / 12, 'år'],
            ['loanFixedRateTerms', campaign.loanFixedRateTerms, 'mnd']
          );
        }
      }

      if (campaign.lease) {
        variablesLocked.push(
          ['leaseName', campaign.lease.name, false],
          ['leaseTerm', campaign.lease.term, false],
          ['leaseTermYears', campaign.lease.term / 12, false],
          ['leaseAdvance', Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(campaign.lease.advance), ',-'],
          ['leaseArrangementFee', Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(campaign.lease.arrangementFee), ',-'],
          ['leaseInterest', Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(campaign.lease.interest), false],
          ['leasePrice', Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(campaign.lease.price), ',-'],
          ['leaseTotal', Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(
            (campaign.lease.price * campaign.lease.term) + campaign.lease.advance + campaign.lease.arrangementFee
          ), ',-']
        );
      }

      let dealerTags = [];
      this.props.dealers.forEach((dealer) => {
        if (dealer.groupTags && dealer.groupTags.length > 0) {
          dealerTags.push(...dealer.groupTags);
        }
      });

      // Only keep unique, and sort
      dealerTags = [...new Set(dealerTags)].sort();

      let mmvCls = 'success';
      if (!campaign.makes) {
        mmvCls = 'danger';
      } else if (campaign.model) {
        if (!campaign.model.published) {
          mmvCls = 'warning';
        } else if (campaign.model.updated) {
          mmvCls = 'info';
        }
        if (campaign.variants) {
          if (campaign.variants.find((v) => !v.published)) {
            mmvCls = 'warning';
          } else if (campaign.variants.find((v) => v.updated)) {
            mmvCls = 'info';
          }
        }
      }

      const popoverHiddenCampaign = (
        <Popover id="popover-mypage">
          Skjuler kampanjen fra kampanjelisting på forsiden og på kampanjesiden.
        </Popover>
      );
      const popoverHideModel = (
        <Popover id="popover-mypage">
          Fjerner modellboksen nederst i kampanjen ved siden av CTA som linker til modellsiden.
        </Popover>
      );
      const popoverShowOnModel = (
        <Popover id="popover-mypage">
          List kampanjen på modellsiden. Dette vil også gjøre at modellen bruker kampanjeprisen som &quot;fra pris&quot; om dette er satt og er lavere enn standard pris.
        </Popover>
      );

      const overLayIconCreator = (overlay) => <OverlayTrigger trigger={['hover', 'click', 'focus']} placement="left" overlay={overlay}>
        <i className="fa fa-question-circle"></i>
      </OverlayTrigger>;

      const predefinedTags = ['Kampanje'];
      const campaignMakes = campaign?.makes ?? [];
      if (campaignMakes.length > 0) {
        predefinedTags.push(...campaignMakes.map((make) => make.name));
      }
      if (campaign.model) {
        predefinedTags.push(campaign.model.name);
      }

      return (
        <section className="campaign mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to="/campaigns/">Kampanjer</Link></li>
            {campaign.name &&
              <li className="active">{campaign.name}</li>
            }
          </ol>
          <form onSubmit={this.handleSubmit}>
            <div className="page-header">
              <div className="pull-right">
                {this.props.working &&
                  <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
                }
                {!campaign.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    {Boolean(campaign.id) &&
                      <span>Lagre</span>
                    }
                    {!campaign.id &&
                      <span>Opprett kampanje</span>
                    }
                  </button>
                }
                &nbsp;
                {campaign.id &&
                  <button
                    type="button"
                    className="btn btn-default"
                    disabled={this.props.modified || campaign.archived || this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      const newData = {campaign: {}};

                      newData.campaign.id = {
                        $set: undefined
                      };

                      newData.campaign.name = {
                        $set: `Kopi ${campaign.name}`
                      };

                      newData.campaign.url = {
                        $set: `kopi-${campaign.url}`
                      };

                      // Create copy of bodytext blocks without ID so we create new ones
                      newData.campaign.bodytext = {
                        $set: campaign.bodytext.map((b) => {
                          b.id = undefined;
                          return b;
                        })
                      };

                      const props = update(this.props, newData);
                      this.props.onChange(props, () => this.props.onSave(true));
                    }}
                  >
                    <span>Kopier</span>
                  </button>
                }
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={(campaign.published && !campaign.updated) || campaign.archived || this.props.working || this.props.modified}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onPublish();
                  }}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={(!campaign.archived && campaign.draft) || this.props.working || this.props.modified || campaign.archived}
                  onClick={(e) => {
                    e.preventDefault();
                    if (campaign.archived) {
                      this.props.onUnarchive();
                    } else {
                      this.props.onUnpublish();
                    }
                  }}
                >
                  <span>Kladd</span>
                </button>
                &nbsp;
                {!campaign.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                &nbsp;
                {campaign.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnarchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>
              <h1>
                {campaign.name} <PublishStatusDot entry={campaign} />
                <br/>
                <small>{printCampaignVisibility(campaign)} Kampanje</small>
              </h1>
            </div>

            {/* Display any error message: */}
            {this.props.error &&
              <div className="alert alert-danger">
                {this.props.error}
              </div>
            }

            {/* Tabs */}
            <ul className="nav nav-tabs" role="tablist">
              <li role="general" className="active">
                <a href="#general" aria-controls="general" role="tab" data-toggle="tab">Generelt</a>
              </li>

              <li role="included">
                <a href="#included" aria-controls="included" role="tab" data-toggle="tab">Inkludert</a>
              </li>

              <li role="callToAction">
                <a href="#callToAction" aria-controls="callToAction" role="tab" data-toggle="tab">Call to action</a>
              </li>

              <li role="publish">
                <a href="#publish" aria-controls="publish" role="tab" data-toggle="tab">Publisering</a>
              </li>

              <li role="metadata">
                <a href="#metadata" aria-controls="metadata" role="tab" data-toggle="tab">Metadata</a>
              </li>
            </ul>

            {/* Tab content */}
            <div className="tab-content mf-margin-bottom-40">

              {/* // GENERAL */}
              <div role="tabpanel" className="tab-pane active" id="general">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <h3>Innhold</h3>
                    <div className="form-group">
                      <label>Kampanjetype <em className="small text-muted">(Påkrevet)</em></label>
                      <select
                        className="form-control"
                        name="type"
                        defaultValue={campaign.type}
                        disabled={this.props.working || campaign.archived || campaign.type === 'Reservasjon'}
                        onChange={this.handleFieldChange}
                        required
                      >
                        <option value="">-- Velg type kampanje --</option>
                        <option value="newcar">Nybilkampanje</option>
                        <option value="newcar-loan">Rentekampanje</option>
                        <option value="newcar-fixed-rate-loan">Fastrentekampanje</option>
                        <option value="parts">Tilbehørskampanje</option>
                        <option value="service">Servicekampanje</option>
                        <option value="reservation" disabled>Reservasjon</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Navn <em className="small text-muted">(Påkrevet)</em></label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        defaultValue={campaign.name}
                        disabled={this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>

                    <div className="row">
                      <div className="col-xs-12 col-md-6">
                        <div className="form-group">
                          <label>Hovedbilde <em className="small text-muted">(Påkrevet)</em></label>
                          <AssetField
                            name="mainImage"
                            value={campaign.mainImage}
                            onChange={this.handleAssetChange}
                            disabled={this.props.working || campaign.archived}
                            allowVideo
                            predefinedTags={predefinedTags}
                          />
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-6">
                        <div className="form-group">
                          <label>Listebilde <em className="small text-muted">(Påkrevet)</em></label>
                          <AssetField
                            name="listImage"
                            value={campaign.listImage}
                            onChange={this.handleAssetChange}
                            disabled={this.props.working || campaign.archived}
                            predefinedTags={predefinedTags}
                          />
                        </div>
                      </div>
                    </div>

                    {!campaign.externalCampaignPage &&
                      <div className="form-group">
                        <label>URL (navn) <em className="small text-muted"></em></label>
                        <input
                          type="text"
                          className="form-control"
                          pattern="^([\w,.-])+?$"
                          name="url"
                          value={this.state.campaignUrl}
                          disabled={campaign.published || this.props.working || campaign.archived}
                          onChange={this.handleFieldChange}
                        />
                      </div>
                    }

                    <div className="form-group">
                      <label>Undertittel <em className="small text-muted">(Påkrevet)</em></label>
                      <textarea
                        className="form-control"
                        name="description"
                        rows="2"
                        defaultValue={campaign.description}
                        disabled={this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Tekst på bilde bakgrunn</label>
                      <select
                        className="form-control"
                        defaultValue={campaign.titleBackground}
                        name="titleBackground"
                        disabled={this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                      >
                        <option value="">Overskrift i header (Standard)</option>
                        <option value="white">Hvit bakgrunn med svart tekst (Lyst bilde)</option>
                        <option value="black">Svart bakgrunn med hvit tekst (Mørkt bilde)</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Intro</label>
                      <input
                        type="text"
                        className="form-control"
                        name="intro"
                        defaultValue={campaign.intro}
                        disabled={this.props.working || campaign.archived || !campaign.titleBackground}
                        onChange={this.handleFieldChange}
                      />
                    </div>
                  </div>

                  {campaign.type !== 'reservation' &&
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Visning</label>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="hiddenCampaign" defaultChecked={campaign.hiddenCampaign} onChange={this.handleFieldChange} disabled={this.props.working || campaign.archived} />
                          skjul kampanjen fra kampanjeoversikten
                        </label>
                        &nbsp;{overLayIconCreator(popoverHiddenCampaign)}
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="hideCarPreview" defaultChecked={campaign.hideCarPreview} onChange={this.handleFieldChange} disabled={!campaign.model || this.props.working || campaign.archived} />
                          Skjul forhåndsvisning av modell på kampanjeside
                        </label>
                        &nbsp;{overLayIconCreator(popoverHideModel)}
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="showCampaignOnModelPage" defaultChecked={campaign.showCampaignOnModelPage} onChange={this.handleFieldChange} disabled={!campaign.model || this.props.working || campaign.archived} />
                          Vis forhåndsvisning av kampanje på modellside
                        </label>
                        &nbsp;{overLayIconCreator(popoverShowOnModel)}
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="showCampaignInConfigurator" defaultChecked={campaign.showCampaignInConfigurator} onChange={this.handleFieldChange} disabled={!campaign.model || !campaign.showCampaignOnModelPage || this.props.working || campaign.archived} />
                          Vis kampanjen i bilkonfiguratoren
                        </label>
                      </div>
                      {campaign.showCampaignInConfigurator && (campaign.type === 'newcar-loan' || campaign.type === 'newcar-fixed-rate-loan') && <div className="checkbox">
                        <label>
                          <input type="checkbox" name="loanExclusive" defaultChecked={campaign.loanExclusive} onChange={this.handleFieldChange} disabled={!campaign.model || !campaign.showCampaignOnModelPage || this.props.working || campaign.archived} />
                          Rentekampanjen kan ikke kombineres med andre kampanjer
                        </label>
                      </div>}
                    </div>

                    <div className="form-group">
                      <MakeModelVariantField
                        onChange={this.handleMakeModelVariantChange}
                        cls={mmvCls}
                        disabled={this.props.working || campaign.archived}
                        value={{
                          makes: campaign.makes || [],
                          model: campaign.model || null,
                          variants: campaign.variants || null
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <h3>Finansiering</h3>
                      <h4>Leasingtilbud</h4>
                      {(!campaign.variants || !campaign.variants.length) &&
                        <span className="help-block">Finansiering krever kobling mot spesifikk variant</span>
                      }
                      <EntityField
                        name="lease"
                        contentType="lease"
                        value={campaign.lease}
                        onChange={this.handleAssetChange}
                        disabled={!campaign.variants || !campaign.variants.length || campaign.variants.length !== 1 || this.props.working || campaign.archived}
                        searchParams={{
                          links_to_entry: campaign.variants && campaign.variants.length && campaign.variants[0].id
                        }}
                        searchOnOpen={true}
                        allowEdit={!this.props.modified}
                        createUrl={generateEditLink('lease', `new?variant=${campaign.variants?.length === 1 ? campaign.variants[0].id : ''}`)}
                      />
                    </div>

                    {/* FLETTEFELTER */}
                    <div className="form-group">
                      <h3>Flettefelter</h3>
                      <span className="help-block small">Flettefelter er tilgjengelig i feltene &quot;Navn&quot;, &quot;Intro&quot;, &quot;Undertittel&quot; og &quot;Hovedtekst&quot;.</span>
                      {campaign.type !== 'newcar-loan' && campaign.type !== 'newcar-fixed-rate-loan' && <>
                        <h3>Price</h3>
                        <div className="input-group">
                          <input
                            className="form-control"
                            name="price"
                            rows="2"
                            defaultValue={campaign.price}
                            disabled={this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                          />
                          <div className="input-group-addon">,-</div>
                        </div>
                        <span className="help-block">
                          Vises dersom oppgitt. For nybilkampanjer vil lokalt fraktpåslag legges til valgt bilmodell.
                          <br />
                          Negativ pris kan brukes for å lage en rabattkampanje.
                        </span>
                      </>}
                      {campaign.type === 'newcar-fixed-rate-loan' && (campaign.variants?.length > 0) && <>
                        <h3>Price</h3>
                        <div className="input-group">
                          <input
                            className="form-control"
                            name="price"
                            rows="2"
                            defaultValue={campaign.price}
                            disabled={this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                          />
                          <div className="input-group-addon">,-</div>
                        </div>
                        <span className="help-block">
                          Prisen vil også vises som en vanlig kampanjepris for varianten.
                        </span>
                      </>}
                      {(campaign.type === 'newcar-loan' || campaign.type === 'newcar-fixed-rate-loan') && <>
                        <h3>{campaign.type === 'newcar-loan' ? 'Rente' : 'Fastrente'}</h3>
                        <div className="input-group">
                          <input
                            className="form-control"
                            name="loanRate"
                            rows="2"
                            defaultValue={campaign.loanRate}
                            disabled={this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                            required
                          />
                          <div className="input-group-addon">%</div>
                        </div>
                      </>}

                      {campaign.type === 'newcar-fixed-rate-loan' && <>
                        <h3>Produktrente <em className="small text-muted">(Påkrevet)</em></h3>
                        <div className="input-group">
                          <input
                            className="form-control"
                            name="loanRate2"
                            rows="2"
                            defaultValue={campaign.loanRate2}
                            disabled={this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                            required
                          />
                          <div className="input-group-addon">%</div>
                        </div>
                      </>}

                      {(campaign.type === 'newcar-loan' || campaign.type === 'newcar-fixed-rate-loan') && <>
                        <h3>Minimum egenkapital (i prosent)</h3>
                        <div className="input-group">
                          <input
                            className="form-control"
                            name="minimumEquityPercentage"
                            rows="2"
                            defaultValue={campaign.minimumEquityPercentage}
                            disabled={this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                          />
                          <div className="input-group-addon">%</div>
                        </div>
                      </>}

                      {campaign.type === 'newcar-fixed-rate-loan' && <>
                        <h3>Total nedbetalingstid <em className="small text-muted">(Påkrevet)</em></h3>
                        <select
                          type="text"
                          className="form-control"
                          name="loanRateTotalTerms"
                          defaultValue={campaign.loanRateTotalTerms}
                          disabled={this.props.working || campaign.archived}
                          onChange={this.handleFieldChange}
                          required
                        >
                          <option value="">-- Velg nedbetalingstid --</option>
                          <option value="12">1</option>
                          <option value="24">2</option>
                          <option value="36">3</option>
                          <option value="48">4</option>
                          <option value="60">5</option>
                          <option value="72">6</option>
                          <option value="84">7</option>
                          <option value="96">8</option>
                          <option value="108">9</option>
                          <option value="120">10</option>
                        </select>

                        <h3>Fast pris nedbetalingstid <em className="small text-muted">(Påkrevet)</em></h3>
                        <select
                          type="text"
                          className="form-control"
                          name="loanFixedRateTerms"
                          defaultValue={campaign.loanFixedRateTerms}
                          disabled={this.props.working || campaign.archived}
                          onChange={this.handleFieldChange}
                          required
                        >
                          <option value="">-- Velg nedbetalingstid --</option>
                          <option value="12">1</option>
                          <option value="24">2</option>
                          <option value="36">3</option>
                          <option value="48">4</option>
                          <option value="60">5</option>
                          <option value="72">6</option>
                          <option value="84">7</option>
                          <option value="96">8</option>
                          <option value="108">9</option>
                          <option value="120">10</option>
                        </select>
                      </>}

                      <h3 className="mf-margin-top-10">Egendefinerte felter</h3>
                      <span className="help-block small">
                        Lokalt fraktpåslag vil legges til valgt bilmodell på flettefletene.<br />
                        <strong>
                          Husk å trykke på knappen for &quot;Lagre endringer&quot; <em>før</em> du trykker &quot;Lagre&quot;-knappen for selve kampanjen (øverst).
                        </strong>
                      </span>

                      <CustomVariables
                        namePrepend="#"
                        valuePrepend="="
                        valueAppend=",-"
                        disabled={campaign.archived}
                        variables={campaign.variables}
                        name="variables"
                        onSave={this.handleFieldChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>Faste flettefelter</label>
                      {campaign.type !== 'newcar-loan' && campaign.price && <span className="help-block small">Kun #price vil få lagt til lokalt fraktpåslag</span>}
                      {variablesLocked.map(([lName, lValue, lAddon]) => <div className="row" key={lName}>
                        <div className="col-xs-5">
                          <div className="input-group mf-margin-bottom-5">
                            <div className="input-group-addon">#</div>
                            <input
                              type="text"
                              className="form-control"
                              value={lName}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-xs-5">
                          <div className="input-group mf-margin-bottom-5">
                            <div className="input-group-addon">=</div>
                            <input
                              className="form-control text-right"
                              value={lValue}
                              type="text"
                              disabled
                            />
                            {lAddon && <div className="input-group-addon">{lAddon}</div>}
                          </div>
                        </div>
                        <div className="col-xs-2">
                          <button
                            type="button"
                            className="btn btn-danger"
                            disabled
                            title="Slett dette feltet"
                          >
                            <i className="fa fa-remove"></i>
                          </button>
                        </div>
                      </div>)}
                    </div>
                  </div>
                  }
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    {!campaign.externalCampaignPage &&
                      <div className="form-group" id="bodytext">
                        <label className="h2">Hovedtekst</label>
                        <hr />
                        <BlockEditor
                          blocks={campaign.bodytext}
                          onChange={(blocks) => this.handleAssetChange('bodytext', blocks)}
                          disabled={this.props.working || campaign.archived}
                          enableLeaseWidget
                          enableTwoColumns
                          allowVideo
                          predefinedTags={predefinedTags}
                        />
                      </div>
                    }
                  </div>
                </div>
              </div>
              {/* // GENERAL */}

              {/* Included */}
              <div role="tabpanel" className="tab-pane" id="included">
                {(!campaign.variants || !campaign.variants.length) &&
                  <div className="row">
                    <div className="col-xs-12 col-md-6">
                      <h3>Krever kobling mot spesifikk variant</h3>
                    </div>
                  </div>
                }
                {(campaign.variants && campaign.variants.length > 0) && <div>
                  <div className="row">
                    <div className="col-xs-12">
                      <label>Inkludert tilbehør</label>
                      <div className="form-group">
                        <EntityCollectionField
                          name="includedEquipments"
                          value={campaign.includedEquipments}
                          contentType="equipment"
                          quickAdd={true}
                          searchParams={{
                            'fields.model.sys.id': campaign.model.id
                          }}
                          searchOnOpen={true}
                          onChange={this.handleAssetChange}
                          disabled={this.props.working || campaign.archived }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <label>Inkludert fabrikkmontert ekstrautstyr</label>
                      <div className="form-group">
                        <EntityCollectionField
                          name="includedFactoryEquipments"
                          value={campaign.includedFactoryEquipments}
                          contentType="equipmentFactory"
                          quickAdd={true}
                          searchParams={{
                            'fields.model.sys.id': campaign.model.id
                          }}
                          searchFilterFn={(eq) => {
                            // Filter the result down to whitelisted variants
                            if (eq.fields.variantWhitelist && eq.fields.variantWhitelist['nb-NO'].find(((v) => campaign.variants.find((cv) => cv.id === v.sys.id)))) {
                              return true;
                            }

                            if (eq.fields.variantWhitelistManual && eq.fields.variantWhitelistManual['nb-NO'].find(((v) => campaign.variants.find((cv) => cv.id === v.sys.id)))) {
                              return true;
                            }

                            return false;
                          }}
                          searchOnOpen={true}
                          onChange={this.handleAssetChange}
                          disabled={this.props.working || campaign.archived }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <label>{campaign.lease ? 'Tilgjengelige farger' : 'Inkluderte farger'}</label>
                      {campaign.lease && <span className="help-block">Legges det ikke til noen farger vil alle farger være tilgjengelige.</span>}
                      <div className="form-group">
                        <label>Fargebeskrivelse <small>Vises i listen over hva som er inkludert på kampanjen. F.eks &quot;Metallic lakk&quot;</small></label>
                        <input
                          type="text"
                          className="form-control"
                          name="colorDescription"
                          defaultValue={campaign.colorDescription}
                          disabled={this.props.working || campaign.archived}
                          onChange={this.handleFieldChange}
                        />
                      </div>
                      <div className="form-group">
                        <EntityCollectionField
                          name="availableColors"
                          value={campaign.availableColors}
                          contentType="color"
                          quickAdd={true}
                          searchParams={{
                            'fields.model.sys.id': campaign.model.id
                            // 'fields.equipmentLevelWhitelist.sys.id[in]': campaign.variants.map((variant) => variant.equipmentLevel.id).join(',')
                          }}
                          searchOnOpen={true}
                          onChange={this.handleAssetChange}
                          disabled={this.props.working || campaign.archived }
                        />
                      </div>
                    </div>
                  </div>
                </div>}
              </div>

              {/* // SETTINGS */}
              <div role="tabpanel" className="tab-pane" id="callToAction">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Overskrift <em className="small text-muted">(Påkrevet)</em></label>
                      <input
                        type="text"
                        className="form-control"
                        name="callToActionHeader"
                        defaultValue={campaign.callToActionHeader}
                        disabled={campaign.externalCampaignPage || this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Tekst <em className="small text-muted">(Påkrevet)</em></label>
                      <textarea
                        className="form-control"
                        name="callToActionText"
                        rows="2"
                        defaultValue={campaign.callToActionText}
                        disabled={campaign.externalCampaignPage || this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Knappetekst <em className="small text-muted">(Påkrevet)</em></label>
                      <input
                        type="text"
                        className="form-control"
                        name="callToActionButtonText"
                        defaultValue={campaign.callToActionButtonText}
                        disabled={this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>Info <small className="small text-muted">Tekst over knapp</small></label>
                      <input
                        type="text"
                        className="form-control"
                        name="callToActionInfo"
                        defaultValue={campaign.callToActionInfo}
                        disabled={this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                      />
                    </div>

                    {campaign.type !== 'reservation' &&
                    <div className="form-group">
                      <label>Skjematype <em className="small text-muted">(Påkrevet)</em></label>
                      <select
                        type="text"
                        className="form-control"
                        name="callToActionForm"
                        defaultValue={campaign.callToActionForm}
                        disabled={campaign.externalCampaignPage || this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                        required
                      >
                        <option value="">-- Velg type skjema --</option>
                        <option value="TestDrive">Prøvekjøring</option>
                        <option value="Workshop">Verksted</option>
                        <option value="Campaign">Standard kampanjeskjema</option>
                        <option value="DigitalConsulting">Digitalt møte</option>
                        <option value="CarQuestion">Bilforespørsel</option>
                        <option value="CarParts">Deler</option>
                        <option value="external">Egendefinert</option>
                      </select>
                    </div>
                    }
                    {campaign.callToActionForm === 'external' &&
                      <div className="form-group">
                        <label>Egendefinert skjema <em className="small text-muted">(Påkrevet)</em></label>
                        <EntityField
                          name="callToActionFormExt"
                          contentType="leadSchema"
                          value={campaign.callToActionForm === 'external' && campaign.callToActionFormExt}
                          onChange={this.handleAssetChange}
                          disabled={campaign.externalCampaignPage || this.props.working || campaign.archived || campaign.callToActionForm !== 'external'}
                          searcher={createSearcher('leadSchema')}
                          searchOnOpen={true}
                          allowEdit={!this.props.modified}
                        />
                      </div>
                    }
                  </div>

                  {campaign.type !== 'reservation' &&
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Ekstern url for påmelding <em
                        className="small text-muted">{campaign.externalCampaignPage ? '(Påkrevet)' : ''}</em></label>
                      <div className="input-group">
                        <div className="input-group-addon">Url</div>
                        <input
                          type="text"
                          className="form-control"
                          name="callToActionUrlExternal"
                          defaultValue={campaign.callToActionUrlExternal}
                          disabled={this.props.working || campaign.archived}
                          onChange={this.handleFieldChange}
                          required={campaign.externalCampaignPage}
                        />
                      </div>
                    </div>
                    <span className="help-block">Angi ekstern url/nettadresse dersom kampanjen skal lede til en ekstern landingsside.</span>
                    <div className="form-group">
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="externalCampaignPage" defaultChecked={campaign.externalCampaignPage} onChange={this.handleFieldChange} disabled={this.props.working || campaign.archived}/>
                          <strong>Ekstern kampanjeside</strong>
                        </label>
                      </div>
                      <span className="help-block">
                        Vil lenke kampanjen direkte til ekstern side.
                        <br/>
                        Ingen kampanjeside vil bli generert.
                      </span>
                    </div>
                  </div>
                  }
                </div>

                {campaign.type !== 'reservation' && <div>
                  <hr/>

                  <div className="row">
                    <div className="col-xs-12 col-md-6">
                      <div className="form-group">
                        <label>Sekundær CTA</label>
                        <div className="checkbox">
                          <label>
                            <input type="checkbox" name="showSecondaryCtaButton" defaultChecked={campaign.showSecondaryCtaButton} onChange={this.handleFieldChange} disabled={this.props.working || campaign.archived}/>
                            <strong>Aktiver</strong>
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Knappetekst <em className="small text-muted">(Påkrevet)</em></label>
                        <input
                          type="text"
                          className="form-control"
                          name="callToActionButtonText2"
                          defaultValue={campaign.callToActionButtonText2}
                          disabled={!campaign.showSecondaryCtaButton || this.props.working || campaign.archived}
                          onChange={this.handleFieldChange}
                        />
                      </div>
                      <div className="form-group">
                        <label>Skjematype <em className="small text-muted">(Påkrevet)</em></label>
                        <select
                          type="text"
                          className="form-control"
                          name="callToActionForm2"
                          defaultValue={campaign.callToActionForm2}
                          onChange={this.handleFieldChange}
                          disabled={!campaign.showSecondaryCtaButton || this.props.working || campaign.archived}
                          required={campaign.callToActionButtonText2}
                        >
                          <option value="">-- Velg type skjema --</option>
                          <option value="TestDrive">Prøvekjøring</option>
                          <option value="Workshop">Verksted</option>
                          <option value="Campaign">Standard kampanjeskjema</option>
                          <option value="DigitalConsulting">Digitalt møte</option>
                          <option value="CarQuestion">Bilforespørsel</option>
                          <option value="CarParts">Deler</option>
                          <option value="external">Egendefinert</option>
                        </select>
                      </div>
                      {campaign.callToActionForm2 === 'external' &&
                      <div className="form-group">
                        <label>Egendefinert skjema <em className="small text-muted">(Påkrevet)</em></label>
                        <EntityField
                          name="callToActionFormExt2"
                          contentType="leadSchema"
                          value={campaign.callToActionForm2 === 'external' && campaign.callToActionFormExt2}
                          onChange={this.handleAssetChange}
                          disabled={campaign.externalCampaignPage || this.props.working || campaign.archived || campaign.callToActionForm2 !== 'external'}
                          searcher={createSearcher('leadSchema')}
                          searchOnOpen={true}
                          allowEdit={!this.props.modified}
                        />
                      </div>
                      }
                      <div className="form-group">
                        <label>Stiltype <em className="small text-muted">(Påkrevet)</em></label>
                        <select
                          type="text"
                          className="form-control"
                          name="callToActionButtonStyle2"
                          onChange={this.handleFieldChange}
                          defaultValue={campaign.callToActionButtonStyle2}
                          disabled={!campaign.showSecondaryCtaButton || this.props.working || campaign.archived}
                          required={campaign.callToActionButtonText2}
                        >
                          <option value="">-- Velg stil --</option>
                          <option value="mg-btn-tertiary-alt">Sekundær</option>
                          <option value="mg-btn-tertiary">Tertiær</option>
                        </select>
                      </div>
                      { (campaign.callToActionForm2 !== 'CarQuestion') &&
                        <div className="form-group">
                          <label>Tittel på skjema</label>
                          <input
                            type="text"
                            className="form-control"
                            name="callToActionTitle2"
                            defaultValue={campaign.callToActionTitle2}
                            disabled={!campaign.showSecondaryCtaButton || this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                            required
                          />
                        </div>
                      }
                      { (campaign.callToActionForm2 !== 'CarQuestion') &&
                        <div className="form-group">
                          <label>Beskrivelse på skjema</label>
                          <textarea
                            type="text"
                            className="form-control"
                            name="callToActionDescription2"
                            defaultValue={campaign.callToActionDescription2}
                            disabled={!campaign.showSecondaryCtaButton || this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                            required
                          />
                        </div>
                      }
                    </div>

                    <div className="col-xs-12 col-md-6 mf-margin-top-70">
                      <div className="form-group">
                        <label>Ekstern url<em
                          className="small text-muted">{campaign.externalCampaignPage ? '(Påkrevet)' : ''}</em></label>
                        <div className="input-group">
                          <div className="input-group-addon">Url</div>
                          <input
                            type="text"
                            className="form-control"
                            name="callToActionUrlExternal2"
                            defaultValue={campaign.callToActionUrlExternal2}
                            disabled={!campaign.showSecondaryCtaButton || this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                          />
                        </div>
                      </div>
                      <span className="help-block">Angi ekstern url/nettadresse dersom kampanjen skal lede til en ekstern landingsside.</span>
                    </div>
                  </div>
                  <hr/>

                  <div className="row">
                    <div className="col-xs-12 col-md-6">
                      <div className="form-group">
                        <label>Tertiær CTA</label>
                        <div className="checkbox">
                          <label>
                            <input type="checkbox" name="showTertiaryCtaButton" defaultChecked={campaign.showTertiaryCtaButton} onChange={this.handleFieldChange} disabled={this.props.working}/>
                            <strong>Aktiver</strong>
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Knappetekst <em className="small text-muted">(Påkrevet)</em></label>
                        <input
                          type="text"
                          className="form-control"
                          name="callToActionButtonText3"
                          defaultValue={campaign.callToActionButtonText3}
                          disabled={!campaign.showTertiaryCtaButton || this.props.working || campaign.archived}
                          onChange={this.handleFieldChange}
                        />
                      </div>
                      <div className="form-group">
                        <label>Skjematype <em className="small text-muted">(Påkrevet)</em></label>
                        <select
                          type="text"
                          className="form-control"
                          name="callToActionForm3"
                          defaultValue={campaign.callToActionForm3}
                          onChange={this.handleFieldChange}
                          disabled={!campaign.showTertiaryCtaButton || this.props.working || campaign.archived}
                          required={campaign.callToActionButtonText3}
                        >
                          <option value="">-- Velg type skjema --</option>
                          <option value="TestDrive">Prøvekjøring</option>
                          <option value="Workshop">Verksted</option>
                          <option value="Campaign">Standard kampanjeskjema</option>
                          <option value="DigitalConsulting">Digitalt møte</option>
                          <option value="CarQuestion">Bilforespørsel</option>
                          <option value="CarParts">Deler</option>
                          <option value="external">Egendefinert</option>
                        </select>
                      </div>
                      {campaign.callToActionForm3 === 'external' &&
                      <div className="form-group">
                        <label>Egendefinert skjema <em className="small text-muted">(Påkrevet)</em></label>
                        <EntityField
                          name="callToActionFormExt3"
                          contentType="leadSchema"
                          value={campaign.callToActionForm3 === 'external' && campaign.callToActionFormExt3}
                          onChange={this.handleAssetChange}
                          disabled={campaign.externalCampaignPage || this.props.working || campaign.archived || campaign.callToActionForm3 !== 'external'}
                          searcher={createSearcher('leadSchema')}
                          searchOnOpen={true}
                          allowEdit={!this.props.modified}
                        />
                      </div>
                      }
                      <div className="form-group">
                        <label>Stiltype <em className="small text-muted">(Påkrevet)</em></label>
                        <select
                          type="text"
                          className="form-control"
                          name="callToActionButtonStyle3"
                          defaultValue={campaign.callToActionButtonStyle3}
                          onChange={this.handleFieldChange}
                          disabled={!campaign.showTertiaryCtaButton || this.props.working || campaign.archived}
                          required={campaign.callToActionButtonText3}
                        >
                          <option value="">-- Velg stil --</option>
                          <option value="mg-btn-tertiary-alt">Sekundær</option>
                          <option value="mg-btn-tertiary">Tertiær</option>
                        </select>
                      </div>
                      { (campaign.callToActionForm3 !== 'CarQuestion') &&
                        <div className="form-group">
                          <label>Tittel på skjema</label>
                          <input
                            type="text"
                            className="form-control"
                            name="callToActionTitle3"
                            defaultValue={campaign.callToActionTitle3}
                            disabled={!campaign.showTertiaryCtaButton || this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                            required
                          />
                        </div>
                      }
                      { (campaign.callToActionForm3 !== 'CarQuestion') &&
                        <div className="form-group">
                          <label>Beskrivelse på skjema</label>
                          <textarea
                            type="text"
                            className="form-control"
                            name="callToActionDescription3"
                            defaultValue={campaign.callToActionDescription3}
                            disabled={!campaign.showTertiaryCtaButton || this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                            required
                          />
                        </div>
                      }
                    </div>
                    <div className="col-xs-12 col-md-6 mf-margin-top-70">
                      <div className="form-group">
                        <label>Ekstern url<em
                          className="small text-muted">{campaign.externalCampaignPage ? '(Påkrevet)' : ''}</em></label>
                        <div className="input-group">
                          <div className="input-group-addon">Url</div>
                          <input
                            type="text"
                            className="form-control"
                            name="callToActionUrlExternal3"
                            defaultValue={campaign.callToActionUrlExternal3}
                            disabled={!campaign.showTertiaryCtaButton || this.props.working || campaign.archived}
                            onChange={this.handleFieldChange}
                          />
                        </div>
                      </div>
                      <span className="help-block">Angi ekstern url/nettadresse dersom kampanjen skal lede til en ekstern landingsside.</span>
                    </div>
                  </div>
                </div>}
              </div>
              {/* // SETTINGS */}

              {/* // PUBLISH */}
              <div role="tabpanel" className="tab-pane" id="publish">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Gjelder f.o.m. - t.o.m. <em className="small text-muted">(Påkrevet)</em></label>
                      <div className="row">
                        <div className="col-xs-6">
                          <DatePicker
                            name="startDate"
                            disabled={this.props.working || campaign.archived}
                            className="form-control"
                            locale="nb"
                            dateFormat="dd.MM.yyyy"
                            selected={campaign.startDate}
                            onChange={(date) => date.setHours(0, 0, 0) && this.handleDateChange('startDate', date)}
                            required
                          />
                        </div>
                        <div className="col-xs-6">
                          <DatePicker
                            name="expiryDate"
                            disabled={this.props.working || campaign.archived}
                            className="form-control"
                            locale="nb"
                            dateFormat="dd.MM.yyyy"
                            selected={campaign.expiryDate}
                            onChange={(date) => date.setHours(23, 59, 59) && this.handleDateChange('expiryDate', date)}
                            required
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xs-6">
                        </div>
                        <div className="col-xs-6">
                          <div className="checkbox">
                            <label>
                              <input type="checkbox" name="hideDates" defaultChecked={campaign.hideDates} onChange={this.handleFieldChange} disabled={this.props.working || campaign.archived} />
                              skjul kampanjens varighet
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <h3>Publiser til forhandlere</h3>

                      {buttons &&
                        <div className="mf-margin-bottom-20">
                          <label>Basert på merke</label><br />
                          {buttons}
                        </div>
                      }

                      <div className="mf-margin-bottom-20">
                        <label>Basert på tag</label><br />
                        <div className="btn-group" role="group">
                          {dealerTags.map((tag, i) => {
                            return (
                              <button
                                key={i}
                                type="button"
                                className="btn btn-default btn-sm"
                                disabled={campaign.archived || this.props.working}
                                onClick={(e) => this.handleDealersUpdate(e, null, tag)}
                              >
                                {tag}
                              </button>
                            );
                          })}
                        </div>
                      </div>

                      <h4 className="mf-margin-bottom-20">Kampanjen er publisert til:</h4>
                      <EntityCollectionField
                        name="dealers"
                        value={campaign.dealers}
                        contentType="forhandler"
                        removeAllButton={true}
                        quickAdd={true}
                        onChange={this.handleAssetChange}
                        disabled={this.props.working || campaign.archived }
                      />

                      <span className="help-block">
                        Angir hvilke forhandlere kampanjen skal vises for.
                      </span>
                    </div>
                  </div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Prioritet <em className="small text-muted">(Påkrevet)</em></label>
                      <input
                        type="number"
                        step="1"
                        className="form-control"
                        name="priority"
                        defaultValue={campaign.priority}
                        disabled={this.props.working || campaign.archived}
                        onChange={this.handleFieldChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="mfRotationOverride" defaultChecked={campaign.mfRotationOverride} onChange={this.handleFieldChange} disabled={this.props.working || campaign.archived || campaign.archived} />
                          Prioritert kampanje på motorforum
                        </label>
                        <span className="help-block">
                          Overstyr tidsrullering av kampanjer på forsiden til motorforum forhandlere.
                          <br />
                          Denne kampanjen vil prioriteres istedenfor automatisk tidsrullering basert på merke.
                        </span>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Merker</label>
                      <EntityCollectionField
                        name="makes"
                        value={campaign.makes}
                        contentType="bilmerker"
                        onChange={this.handleAssetChange}
                        disabled={this.props.working || campaign.archived}
                        searchOnOpen={true}
                      />
                      <span className="help-block">
                        Angir hvilke merkenettsteder kampanjen skal vises på innunder de valgte
                        forhandlerne. Hvis ingen merker er valgt, vil ikke kampanjen vises.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* // PUBLISH */}

              {/* Metadata */}
              <div role="tabpanel" className="tab-pane" id="metadata">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <label>Intern Sammendrag</label>
                    <div className="form-group">
                      <textarea type="text" className="form-control" name="summary" defaultValue={this.props.campaign.summary} disabled={this.props.working || campaign.archived} onChange={this.handleFieldChange} />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <div className="clearfix mf-margin-bottom-10">
                        <label>Metadata / OpenGraph</label>
                      </div>
                      {!this.props.modified && campaign.id &&
                        <Link
                          className="btn btn-default"
                          to={`/opengraph/new/campaign/${this.props.campaign.id}${campaign.makes && campaign.makes.length ? `/${campaign.makes[0].id}` : ''}`}
                        >Opprett egendefinert metadata</Link>
                      }
                      {this.props.modified && <div className="alert alert-info">Du må lagre kampanjen før du kan gjøre endringer på metadata</div>}
                      <div className="mf-margin-top-10">
                        {this.props.opengraphs && this.props.opengraphs.map((og) => (
                          <Entity key={og.id} disabled={this.props.modified || this.props.working || campaign.archived} allowEdit={`/opengraph/campaign/${og.id}`} entity={og} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div> {/* // Tab content */}
          </form>
        </section>
      );
    }
  }
}

Campaign.defaultProps = {
  campaign: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {}
};

export default Campaign;
